import { render, staticRenderFns } from "./ItemBasicLayout.vue?vue&type=template&id=5d76056f&scoped=true&"
import script from "./ItemBasicLayout.vue?vue&type=script&lang=js&"
export * from "./ItemBasicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76056f",
  null
  
)

export default component.exports